// The entry compoment of ADC app.

<template>
  <div class="content-panel">
    <Navbar/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from './common/Navbar';

export default {
  name: 'Autoix',
  components: {
    Navbar,
  },
};
</script>




// WEBPACK FOOTER //
// Autoix.vue?45bcba62